export default __webpack_public_path__ + "static/Find-Secret-parties-to-attend-6f7c9c786979c0567157af6ecd3cef6b.jpg";